var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { sportsDict, datesDict } from "./dict";
import { config } from "./config";
import { FilterBlock } from "./FilterBlock";
import { sportsRetrieversFactory, sportsParserFactory, datesRetrieverFactory, datesParserFactory, sportsStateFactory, datesStateFactory, getTimeZoneObservable } from "../../modes";
/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
var sportRetrieverMock, datesRetrieverMock;
if (process.env.NODE_ENV === "development") {
    var _sportMocks = require("../../modes/sports/mocks");
    var _dateMocks = require("../../modes/dates/mocks");
    sportRetrieverMock = new _sportMocks.SportRetrieverMock();
    datesRetrieverMock = new _dateMocks.DatesRetrieverMock();
}
var FilterBlockRoot = /** @class */ (function (_super) {
    __extends(FilterBlockRoot, _super);
    // constructor sets defaults
    function FilterBlockRoot(domId, options) {
        if (options === void 0) { options = {
            dict: sportsDict,
            cms: config,
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            oddsUtil: {},
            facade: {},
            gameStatus: {},
            timeControl: {},
            panelId: "",
            storageUtils: {},
            userInfo: {}
        }; }
        var _this = _super.call(this, domId, options) || this;
        _this.retrievers = [];
        // if no provided dictionary is not full fill in the missing keys with the base one
        _this.options.dict = __assign({}, (options.cms.mode === "Sport" ? sportsDict : datesDict), (options.dict || {}));
        // merge default and CMS options
        _this.options.cms = __assign({}, config, (options.cms || {}));
        _this.timeZoneObservable = getTimeZoneObservable();
        _this.timeZoneObservable.activate();
        _this.initState();
        if (process.env.NODE_ENV === "development") {
            //export data store to window for debug purposes
            window["FilterBlockDATA"] = _this.state;
        }
        return _this;
    }
    FilterBlockRoot.prototype.initState = function () {
        this.options.cms.mode === "Sport" ?
            this.initSports(this.options.cms) :
            this.initDates(this.options.cms);
    };
    FilterBlockRoot.prototype.initSports = function (cms) {
        this.retrievers = process.env.NODE_ENV === "development" ? [sportRetrieverMock] : sportsRetrieversFactory(cms, this.options.dict, this.timeZoneObservable);
        this.state = sportsStateFactory(cms);
        this.parser = sportsParserFactory(cms, this.retrievers);
    };
    FilterBlockRoot.prototype.initDates = function (cms) {
        var retriever = process.env.NODE_ENV === "development" ? datesRetrieverMock : datesRetrieverFactory(cms, this.options.dict, this.timeZoneObservable);
        this.retrievers.push(retriever);
        this.state = datesStateFactory(cms);
        this.parser = datesParserFactory(cms, retriever);
    };
    FilterBlockRoot.prototype.activate = function () {
        var _this = this;
        this.activateAsync().then(function () { return !_this.isActive && _this.cleanup(); }).catch(function (reason) { return _this.cleanup(); });
        return _super.prototype.activate.call(this, React.createElement(FilterBlock, { state: this.state, config: this.options.cms }));
    };
    FilterBlockRoot.prototype.activateAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.parser.activate(this.state)];
                    case 1:
                        _a.sent();
                        this.state.activate();
                        return [2 /*return*/];
                }
            });
        });
    };
    FilterBlockRoot.prototype.deactivate = function () {
        this.cleanup();
        return _super.prototype.deactivate.call(this);
    };
    FilterBlockRoot.prototype.cleanup = function () {
        this.retrievers.forEach(function (r) { return r.deactivate(); });
        this.state.deactivate();
        this.parser.deactivate();
        this.state.clear();
    };
    FilterBlockRoot.prototype.setParams = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        this.retrievers.forEach(function (r) { return r.setParams.apply(r, __spread(params)); });
    };
    FilterBlockRoot.prototype.setBranch = function (itemId) {
        this.state.selectItemById("" + itemId);
    };
    FilterBlockRoot.prototype.destroy = function () {
        this.timeZoneObservable.deactivate();
        return this;
    };
    FilterBlockRoot.prototype.onPanelEnter = function () {
        this.retrievers.forEach(function (r) { return r.onPanelEnter(); });
        return this;
    };
    FilterBlockRoot.prototype.onPanelLeave = function () {
        this.retrievers.forEach(function (r) { return r.onPanelLeave(); });
        return this;
    };
    return FilterBlockRoot;
}(BaseBlock));
export { FilterBlockRoot };
window["FilterBlock"] = FilterBlockRoot;
broadcastBlockLoad("FilterBlock");
//# sourceMappingURL=index.js.map